const WarningIcon = () => (
	<svg className="w-28 h-28 flex-shrink-0" viewBox="0 0 24 24" fill="none" stroke="#be123c" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
		<circle cx="12" cy="12" r="10" />
		<line x1="12" y1="8" x2="12" y2="12" />
		<line x1="12" y1="16" x2="12.01" y2="16" />
	</svg>
);

const CheckIcon = () => (
	<svg className="w-28 h-28 flex-shrink-0" viewBox="0 0 24 24" fill="none" stroke="#059669" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
		<circle cx="12" cy="12" r="10" />
		<polyline points="9 12 11.5 14.5 16 9.5" />
	</svg>
);

const RoyaltyQualificationBanner = ({
	paidPercentage = 0,
	totalFamilies = 0,
	paidFamilies = 0,
	royaltyToDate = 0,
	projectedRoyalty = 0,
	showProjection = false,
	currency,
}) => {
	const isQualified = paidPercentage >= 50;
	const needPct = Math.max(0, 50 - paidPercentage);
	const familiesNeeded = Math.max(0, Math.ceil(totalFamilies * 0.5) - paidFamilies);

	if (isQualified) {
		const earningAmount = showProjection && projectedRoyalty > 0 ? projectedRoyalty : royaltyToDate;

		return (
			<div className="mb-24 bg-emerald-50 border-l-4 border-emerald-500 rounded-r-lg p-20 flex items-start gap-12">
				<CheckIcon />
				<div className="flex flex-col gap-4">
					<span className="font-semibold text-16 text-emerald-900">Qualified for Royalties</span>
					<span className="text-14 text-emerald-800">
						Your school has met the 50% subscription threshold.
						{earningAmount > 0 && (
							<>
								{' '}Based on your current subscribers, you should earn{' '}
								<strong>{currency(earningAmount)}</strong> this quarter.
							</>
						)}
					</span>
				</div>
			</div>
		);
	}

	return (
		<div className="mb-24 bg-rose-50 border-l-4 border-rose-500 rounded-r-lg p-20 flex items-start gap-12">
			<WarningIcon />
			<div className="flex flex-col gap-4">
				<span className="font-semibold text-16 text-rose-900">Not Yet Qualified for Royalties</span>
				<span className="text-14 text-rose-800">
					You need <strong>{needPct.toFixed(1)}%</strong> more subscribers
					{familiesNeeded > 0 && (
						<>
							{' '}or{' '}
							<strong>
								{familiesNeeded} additional {familiesNeeded === 1 ? 'family' : 'families'}
							</strong>
						</>
					)}{' '}
					to become a paid subscriber in order to qualify for Royalties.
				</span>
				<div className="flex items-center gap-12 text-14 text-rose-700">
					<span>
						Current: <span className="font-semibold">{paidPercentage.toFixed(1)}%</span>
					</span>
					<span className="text-rose-400">•</span>
					<span>
						Target: <span className="font-semibold">50%</span>
					</span>
				</div>
			</div>
		</div>
	);
};

export default RoyaltyQualificationBanner;
